<div id="modal-window">
  <h2 mat-dialog-title>{{ data.title }} <a [mat-dialog-close]="false" class="modal-close-btn"></a></h2>
  <div mat-dialog-content>
    <p>{{ data.content }}</p>
  </div>
  <div mat-dialog-actions class="justify-content-end">
    <button class="modal-btn {{ data.buttonClass }}" mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ data.buttonText }}</button>
  </div>
</div>
